import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=fcb9237a&scoped=true&"
import script from "./Balance.vue?vue&type=script&lang=js&"
export * from "./Balance.vue?vue&type=script&lang=js&"
import style0 from "styles/views/account/balance.css?vue&type=style&index=0&id=fcb9237a&scoped=true&lang=css&"
import style1 from "./Balance.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb9237a",
  null
  
)

export default component.exports